module.exports = __webpack_public_path__ + "img/icon1.bf425c91.png";